/* eslint-disable @typescript-eslint/no-explicit-any */
import { chakra, Stack, StyleProps } from '@eigtech/ui-shared-dave'
import { FormEventHandler, ForwardedRef, forwardRef, JSX, ReactNode } from 'react'
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form'

export type FormProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
> = {
  children: ReactNode
  form: UseFormReturn<TFieldValues, TContext, TTransformedValues>
  id: string
  onSubmit: FormEventHandler<HTMLFormElement>
} & Omit<StyleProps, 'id'>

export const Form = forwardRef(function Form({ children, form, ...props }, ref) {
  return (
    <FormProvider {...form}>
      <chakra.form ref={ref} {...props}>
        <Stack h="full" spacing="4">
          {children}
        </Stack>
      </chakra.form>
    </FormProvider>
  )
}) as <
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
>(
  props: FormProps<TFieldValues, TContext, TTransformedValues> & {
    ref?: ForwardedRef<HTMLFormElement>
  }
) => JSX.Element

export type FormComponent<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
> = typeof Form<TFieldValues, TContext, TTransformedValues>
